import { EUnitOfMeasure } from '../shared/enum';
import {
    TDrain,
    TDrainingCapacity,
    TDrainingDrainPipes,
    TExcavationCalculation,
    TMetricCalculationDrainageChimney,
    TMetricCalculationDrainageTrench,
    TPhaseOneOutput,
    TPhaseTwoOutputCalculationOfPressuresInTheSoil,
    TTimeForStabilization,
    TTimeForSystemStabilization,
    TTotalVolumes,
    TTransitionalRegime,
    TWheelbase,
} from '../shared/iResult';
import { EUnitOfMeasureImperialLabel, EUnitOfMeasureLabel, EUnitOfMeasureMetricLabel } from './enum';

export const id: TPhaseOneOutput = 'id';
export const isSlopeStable: TPhaseOneOutput = 'isSlopeStable';
export const fsStaticMin: TPhaseOneOutput = 'fsStaticMin';
export const fsSeismicMin: TPhaseOneOutput = 'fsSeismicMin';
export const phaseOneOutputFSs: TPhaseOneOutput = 'phaseOneOutputFSs';

export const phaseOneOutputPD = {
    [id]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
    [isSlopeStable]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
    [fsStaticMin]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
    [fsSeismicMin]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
    [phaseOneOutputFSs]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
};

export const slopeAnglePercentage: TDrainingCapacity = 'slopeAnglePercentage';
export const interpolationOnLoad: TDrainingCapacity = 'interpolationOnLoad';
export const specificDrainingCapacity: TDrainingCapacity = 'specificDrainingCapacity';
export const drainageCapacityOfASingleDrainPerMeter: TDrainingCapacity = 'drainageCapacityOfASingleDrainPerMeter';
export const entireLineDrainingCapacity: TDrainingCapacity = 'entireLineDrainingCapacity';
export const dischargeToBeDrained: TDrainingCapacity = 'dischargeToBeDrained';
export const specificDischargeToBeDrained: TDrainingCapacity = 'specificDischargeToBeDrained';
export const fsDrainingCapacity: TDrainingCapacity = 'fsDrainingCapacity';
export const isOkDrainingCapacity: TDrainingCapacity = 'isOkDrainingCapacity';

export const drainingCapacityPD = {
    [slopeAnglePercentage]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureLabel.percentage,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureLabel.percentage,
        },
    },
    [interpolationOnLoad]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
    [specificDrainingCapacity]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
    [drainageCapacityOfASingleDrainPerMeter]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.cubicMeterPerSecondMeter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.cubicFootPerSecondFoot,
        },
    },
    [entireLineDrainingCapacity]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.cubicMeterPerSecond,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.cubicFootPerSecond,
        },
    },
    [dischargeToBeDrained]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.cubicMeterPerSecond,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.cubicFootPerSecond,
        },
    },
    [specificDischargeToBeDrained]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.cubicMeterPerSecondMeter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.cubicFootPerSecondFoot,
        },
    },
    [fsDrainingCapacity]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
    [isOkDrainingCapacity]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
};

export const timeForStabilization: TTransitionalRegime = 'timeForStabilization';
export const timeForStabilizationWithChimneys: TTransitionalRegime = 'timeForStabilizationWithChimneys';
export const numberOfChimneysPerLine: TTransitionalRegime = 'numberOfChimneysPerLine';
export const surfaceOfDrainedArea: TTransitionalRegime = 'surfaceOfDrainedArea';
export const drainSurface: TTransitionalRegime = 'drainSurface';
export const chimneysSurface: TTransitionalRegime = 'chimneysSurface';
export const equivalentPermeabilityOverDrainedArea: TTransitionalRegime = 'equivalentPermeabilityOverDrainedArea';
export const equivalentPermeabilityWithChimneys: TTransitionalRegime = 'equivalentPermeabilityWithChimneys';

export const transitionalRegimePD = {
    [timeForStabilization]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
    [timeForStabilizationWithChimneys]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
    [numberOfChimneysPerLine]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
    [surfaceOfDrainedArea]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
    [drainSurface]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
    [chimneysSurface]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
    [equivalentPermeabilityOverDrainedArea]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
    [equivalentPermeabilityWithChimneys]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
};

export const hours: TTimeForStabilization | TTimeForSystemStabilization = 'hours';
export const days: TTimeForStabilization | TTimeForSystemStabilization = 'days';

export const timePD = {
    [hours]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureLabel.hours,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureLabel.hours,
        },
    },
    [days]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureLabel.days,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureLabel.days,
        },
    },
};

export const designedSpacing: TWheelbase = 'designedSpacing';
export const maximumSpacing: TWheelbase = 'maximumSpacing';
export const check: TWheelbase = 'check';
export const suggestedSpacing: TWheelbase = 'suggestedSpacing';

export const wheelbasePD = {
    [designedSpacing]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.meter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.foot,
        },
    },
    [maximumSpacing]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.meter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.foot,
        },
    },
    [check]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
    [suggestedSpacing]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.meter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.foot,
        },
    },
};

export const weightOfWaterVolume: TPhaseTwoOutputCalculationOfPressuresInTheSoil = 'weightOfWaterVolume';
export const coefficientOfEarthPressureAtRest: TPhaseTwoOutputCalculationOfPressuresInTheSoil = 'coefficientOfEarthPressureAtRest';
export const coefficientOfActiveEarthPressure: TPhaseTwoOutputCalculationOfPressuresInTheSoil = 'coefficientOfActiveEarthPressure';
export const coefficientOfPassiveEarthPressure: TPhaseTwoOutputCalculationOfPressuresInTheSoil = 'coefficientOfPassiveEarthPressure';
export const activeFailureInclination: TPhaseTwoOutputCalculationOfPressuresInTheSoil = 'activeFailureInclination';
export const passiveFailureInclination: TPhaseTwoOutputCalculationOfPressuresInTheSoil = 'passiveFailureInclination';
export const verticalPressure: TPhaseTwoOutputCalculationOfPressuresInTheSoil = 'verticalPressure';
export const longTermDrain: TPhaseTwoOutputCalculationOfPressuresInTheSoil = 'longTermDrain';
export const shortTermDrain: TPhaseTwoOutputCalculationOfPressuresInTheSoil = 'shortTermDrain';

export const phaseTwoOutputCalculationOfPressuresInTheSoilPD = {
    [weightOfWaterVolume]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.kilonewtonPerCubicMeter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.poundForcePerCubicFoot,
        },
    },
    [coefficientOfEarthPressureAtRest]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
    [coefficientOfActiveEarthPressure]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
    [coefficientOfPassiveEarthPressure]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
    [activeFailureInclination]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
    [passiveFailureInclination]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
    [verticalPressure]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.kilonewtonPerSquareMeter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.poundForcePerSquareFoot,
        },
    },
    [longTermDrain]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
    [shortTermDrain]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
};

export const horizontalPressureDrainedActiveFailure: TDrain = 'horizontalPressureDrainedActiveFailure';
export const isPrimaryDrainageTrenchOk: TDrain = 'isPrimaryDrainageTrenchOk';
export const isSecondaryDrainageTrenchOk: TDrain = 'isSecondaryDrainageTrenchOk';
export const horizontalPressureDrainedPassiveFailure: TDrain = 'horizontalPressureDrainedPassiveFailure';
export const horizontalPressureCoherentSoilActiveFailure: TDrain = 'horizontalPressureCoherentSoilActiveFailure';
export const horizontalPressureCoherentSoilPassiveFailure: TDrain = 'horizontalPressureCoherentSoilPassiveFailure';
export const depthOfHorizontalStressNullificationDrained: TDrain = 'depthOfHorizontalStressNullificationDrained';
export const horizontalPressureUndrainedShortTermActiveFailure: TDrain = 'horizontalPressureUndrainedShortTermActiveFailure';
export const horizontalPressureUndrainedShortTermPassiveFailure: TDrain = 'horizontalPressureUndrainedShortTermPassiveFailure';
export const depthOfHorizontalStressNullificationUndrained: TDrain = 'depthOfHorizontalStressNullificationUndrained';

export const drainPD = {
    [horizontalPressureDrainedActiveFailure]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.kilonewtonPerSquareMeter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.poundForcePerSquareFoot,
        },
    },
    [isPrimaryDrainageTrenchOk]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
    [isSecondaryDrainageTrenchOk]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
    [horizontalPressureDrainedPassiveFailure]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.kilonewtonPerSquareMeter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.poundForcePerSquareFoot,
        },
    },
    [horizontalPressureCoherentSoilActiveFailure]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.kilonewtonPerSquareMeter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.poundForcePerSquareFoot,
        },
    },
    [horizontalPressureCoherentSoilPassiveFailure]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.kilonewtonPerSquareMeter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.poundForcePerSquareFoot,
        },
    },
    [depthOfHorizontalStressNullificationDrained]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.meter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.foot,
        },
    },
    [horizontalPressureUndrainedShortTermActiveFailure]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.kilonewtonPerSquareMeter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.poundForcePerSquareFoot,
        },
    },
    [horizontalPressureUndrainedShortTermPassiveFailure]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.kilonewtonPerSquareMeter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.poundForcePerSquareFoot,
        },
    },
    [depthOfHorizontalStressNullificationUndrained]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.meter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.foot,
        },
    },
};

export const centralAngle: TDrainingDrainPipes = 'centralAngle';
export const wettedArea: TDrainingDrainPipes = 'wettedArea';
export const wettedPerimeter: TDrainingDrainPipes = 'wettedPerimeter';
export const hydraulicRadius: TDrainingDrainPipes = 'hydraulicRadius';
export const velocity: TDrainingDrainPipes = 'velocity';
export const dischargeDisposedOfByEachPanel: TDrainingDrainPipes = 'dischargeDisposedOfByEachPanel';
export const ratioWithDrainageCapacityQtQdren: TDrainingDrainPipes = 'ratioWithDrainageCapacityQtQdren';
export const isOkRatioWithDrainageCapacityQtQdren: TDrainingDrainPipes = 'isOkRatioWithDrainageCapacityQtQdren';

export const drainingDrainPipesPD = {
    [centralAngle]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureLabel.rad,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureLabel.rad,
        },
    },
    [wettedArea]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.squareMeter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.squareFoot,
        },
    },
    [wettedPerimeter]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.meter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.foot,
        },
    },
    [hydraulicRadius]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.meter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.foot,
        },
    },
    [velocity]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.meterPerSecond,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.footPerSecond,
        },
    },
    [dischargeDisposedOfByEachPanel]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.cubicMeterPerSecond,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.cubicFootPerSecond,
        },
    },
    [ratioWithDrainageCapacityQtQdren]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
    [isOkRatioWithDrainageCapacityQtQdren]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
};

export const amountDrainageTrench: TMetricCalculationDrainageTrench = 'amount';
export const nameDrainageTrench: TMetricCalculationDrainageTrench = 'name';
export const sizeDrainageTrench: TMetricCalculationDrainageTrench = 'size';
export const rectangleArea: TMetricCalculationDrainageTrench = 'rectangleArea';
export const trapezoidArea: TMetricCalculationDrainageTrench = 'trapezoidArea';
export const excavationArea: TMetricCalculationDrainageTrench = 'excavationArea';
export const excavationVolume: TMetricCalculationDrainageTrench = 'excavationVolume';
export const backfillVolume: TMetricCalculationDrainageTrench = 'backfillVolume';
export const landfillVolume: TMetricCalculationDrainageTrench = 'landfillVolume';

export const metricCalculationDrainageTrenchPD = {
    [amountDrainageTrench]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureLabel.amount,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureLabel.amount,
        },
    },
    [nameDrainageTrench]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
    [sizeDrainageTrench]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
    [rectangleArea]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.squareMeter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.squareFoot,
        },
    },
    [trapezoidArea]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.squareMeter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.squareFoot,
        },
    },
    [excavationArea]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.squareMeter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.squareFoot,
        },
    },
    [excavationVolume]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.cubicMeter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.cubicFoot,
        },
    },
    [backfillVolume]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.cubicMeter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.cubicFoot,
        },
    },
    [landfillVolume]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.cubicMeter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.cubicFoot,
        },
    },
};

export const amountDrainageChimney: TMetricCalculationDrainageChimney = 'amount';
export const sizeDrainageChimney: TMetricCalculationDrainageChimney = 'size';

export const metricCalculationDrainageChimneyPD = {
    [amountDrainageChimney]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureLabel.amount,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureLabel.amount,
        },
    },
    [sizeDrainageChimney]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
};

export const excavationSlope: TExcavationCalculation = 'excavationSlope';
export const verticalHeight: TExcavationCalculation = 'verticalHeight';
export const maximumDepth: TExcavationCalculation = 'maximumDepth';
export const excavationStabilityCheck: TExcavationCalculation = 'excavationStabilityCheck';

export const excavationCalculationPD = {
    [excavationSlope]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureLabel.deg,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureLabel.deg,
        },
    },
    [verticalHeight]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.meter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.foot,
        },
    },
    [maximumDepth]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.meter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.foot,
        },
    },
    [excavationStabilityCheck]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
};

export const totalExcavationVolume: TTotalVolumes = 'totalExcavationVolume';
export const totalBackfillVolume: TTotalVolumes = 'totalBackfillVolume';
export const totalDisposalVolume: TTotalVolumes = 'totalDisposalVolume';

export const totalVolumesPD = {
    [totalExcavationVolume]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.cubicMeter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.cubicFoot,
        },
    },
    [totalBackfillVolume]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.cubicMeter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.cubicFoot,
        },
    },
    [totalDisposalVolume]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.cubicMeter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.cubicFoot,
        },
    },
};
